import { render, staticRenderFns } from "./MgmProfileAvatar.vue?vue&type=template&id=2cf9610c&scoped=true&"
import script from "./MgmProfileAvatar.vue?vue&type=script&lang=js&"
export * from "./MgmProfileAvatar.vue?vue&type=script&lang=js&"
import style0 from "./MgmProfileAvatar.vue?vue&type=style&index=0&id=2cf9610c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf9610c",
  null
  
)

export default component.exports